if (!window.RC) { window.RC = {}; }
window.RC.SalesTax  = (function($) {
  const DEFAULT_RATE = { label: 'Sales Tax (0%)', rate: 0.00 };
  let taxField, provField;
  let changing = false;
  let taxRates;

  function init() {
    taxField = document.querySelector('.railcan_tax_field');
    if (!taxField) { return; }
    provField = document.querySelector('.railcan_province_field');
    if (!provField) { return; }
    
    // Tax field is read-only
    taxField.querySelector('.ginput_amount').setAttribute('readonly', 'readonly');
    taxRates = getTaxRates();
    
    gform.addAction('gform_input_change', updateTax);
    updateTax();
  }
  
  function updateTax() {
    if (changing) { return; }
    changing = true;
    
    const prov = $(provField.querySelector('select')).val();
    const subtotal = calcSubtotal();

    const rate = taxRates[prov] || DEFAULT_RATE;
    const tax = calcTax(rate, subtotal);
    const taxStr = "$ " + (Math.round(tax * 100) / 100).toFixed(2) + " CAD";

    const $taxPrice = $(taxField.querySelector('.ginput_amount'));
    $taxPrice.val(taxStr).change();
    
    const taxLabel = taxField.querySelector('.gform-field-label');
    taxLabel.innerText = `${ rate.label } (${ rate.ratePct }%)`;

    changing = false;
  }
  
  function calcSubtotal() {
    const productFields = Array.from(document.querySelectorAll('.gfield--type-product'));
    const productValues = productFields.map(field => {
      if (field.classList.contains('railcan_tax_field')) { return 0; }
      
      const perUnitField = field.querySelector('[id^=ginput_base_price]');
      const quantityField = field.querySelector('.ginput_quantity');
      
      if (!perUnitField || !quantityField) {
        console.error("Could not find price or quantity field for product", field);
        return 0;
      }

      const perUnitStr = perUnitField.value.replace(/[^0-9\.]/g, '');
      const quantityStr = quantityField.value.replace(/[^0-9]/g, '');
      
      if (!perUnitStr || !quantityStr) {
        return 0; 
      }
      
      const perUnit = Number.parseFloat(perUnitStr);

      if (Number.isNaN(perUnit)) {
        console.error("Could not parse unit price on field", perUnitField.value, perUnitField);
        return 0;
      }

      const quantity = Number.parseInt(quantityStr);
      
      if (Number.isNaN(quantity)) {
        console.error("Could not parse quantity on field", quantityField.value, quantityField);
        return 0;
      }

      return quantity * perUnit;
    });
    
    // Sum values.
    return productValues.reduce((a, v) => a + v, 0);
  }
  
  function calcTax(rate, subtotal) {
    if (!rate || !rate.rate) { return 0; }
    return Math.round(subtotal * rate.rate) / 100;
  }
  
  function getTaxRates() {
    const taxRates = {};
    const taxSettings = window.RailcanVars && window.RailcanVars.salesTax;
    const lang = (window.wp_localize && window.wp_localize.lang) || 'en';
    DEFAULT_RATE.label = (lang === 'fr') ? 'Taxe de vente' : 'Sales Tax';
    
    if (!taxSettings || !(taxSettings instanceof Array)) { return taxRates; }
    
    taxSettings.forEach(rate => {
      const rateFloat = parseFloat(rate.rate);
      
      if (Number.isNaN(rateFloat)) { return; }
    
      taxRates[rate.province] = {
        label: rate['label_' + lang],
        rate: rateFloat,
        ratePct: rate.rate
      }
    });
    
    return taxRates;
  }

  init();
})(jQuery);